import * as type from '../ActionTypes';

const initialState = {
  loading: false,
  saveMilestone: false,
  error: null,
  editMilestone: false,
  isEditButton: false,
  activeMilestoneId: null
};
export default function milestoneReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.POST_MILESTONE_REQUEST:
      return {
        ...initialState,
        loading: true
      };
    case type.POST_MILESTONE_SUCCESS:
      return {
        loading: false,
        saveMilestone: true,
        error: null
      };
    case type.POST_MILESTONE_FAILURE:
      return {
        loading: false,
        saveMilestone: false,
        error: action?.error
      };
    case type.PUT_MILESTONE_REQUEST:
      return {
        ...initialState,
        loading: true
      };
    case type.PUT_MILESTONE_SUCCESS:
      return {
        loading: false,
        editMilestone: true,
        error: null
      };
    case type.PUT_MILESTONE_FAILURE:
      return {
        loading: false,
        editMilestone: false,
        error: action?.error
      };
    case type.SET_ISEDITE_MILESTONE:
      return {
        ...initialState,
        isEditButton: true,
        activeMilestoneId: action.payload
      };
    case type.RESET_MILESTONE_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
